import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from 'semantic-ui-react';
import ISearchButtonProps from '../interfaces/ISearchButtonProps';

/** Search Button
 * @param {string} title - Button title
 * @param {boolean} hide - hide the button
 * @link https://react.semantic-ui.com/elements/button/
 **/
const SearchButton: React.FC<ISearchButtonProps> = (props: ISearchButtonProps) => {

    const { t } = useTranslation();
    const { title, hidden=false, color, labelPosition, type, ...rest } = props;

    if (hidden) return null;

    return (
        <Button
            icon
            className='extended-button'
            color={color ? color : undefined}
            labelPosition={labelPosition ? labelPosition : 'left'}
            type={type ? type : 'reset'}
            {...rest}
        >
            <Icon name={'search'} />
            {title ? title : t('components.search.title')}
        </Button>
    );

};

export default SearchButton;
